const initPagesSliderWidget = () => {
    if (document.querySelectorAll(".category").length == 0 || window.innerWidth <= 1024) {
        const flickitySlidersArray = initCarousel("[data-pages-slider] [data-slider]", cellAlign.center, true, false, true, true, false);
    }
};
